module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[91]334.71535d9.woff2";